/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SurveyAnswer model module.
 * @module model/SurveyAnswer
 * @version 1.0.0
 */
class SurveyAnswer {
    /**
     * Constructs a new <code>SurveyAnswer</code>.
     * A possible answer for a survey question
     * @alias module:model/SurveyAnswer
     */
    constructor() { 
        
        SurveyAnswer.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SurveyAnswer</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SurveyAnswer} obj Optional instance to populate.
     * @return {module:model/SurveyAnswer} The populated <code>SurveyAnswer</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SurveyAnswer();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('answer_text')) {
                obj['answer_text'] = ApiClient.convertToType(data['answer_text'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
            if (data.hasOwnProperty('requires_specification')) {
                obj['requires_specification'] = ApiClient.convertToType(data['requires_specification'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * Answer identifier
 * @member {Number} id
 */
SurveyAnswer.prototype['id'] = undefined;

/**
 * Answer text
 * @member {String} answer_text
 */
SurveyAnswer.prototype['answer_text'] = undefined;

/**
 * Order of the answer in the question
 * @member {Number} order
 */
SurveyAnswer.prototype['order'] = undefined;

/**
 * Whether the answer requires additional specification
 * @member {Boolean} requires_specification
 */
SurveyAnswer.prototype['requires_specification'] = undefined;






export default SurveyAnswer;

